export enum BillingActionEnum {
	Lock = "Lock",
	Unlock = "Unlock",
	SendBilling = "SendBilling",
	SendReceipt = "SendReceipt",
	Pay = "Pay"
}
